import React from 'react';
import { styled } from 'baseui';
import { Button, SIZE } from 'baseui/button';
import { Pagination } from 'baseui/pagination';
import { DIVIDER, SIZE as TABLESIZE, Table } from 'baseui/table-semantic';
import UserManagementModal from './user-management-modal';
const Div = styled('div', {
  width: '100%'
});
const ButtonContainer = styled('div', ({
  $theme
}) => ({
  marginBottom: $theme.sizing.scale600,
  marginTop: $theme.sizing.scale600
}));
type UserManagementProps = {
  users: any[];
  pageNumber: number;
  totalPages: number;
  setPageNumber: (pageNumber: number) => void;
};
const UserManagement = (props: UserManagementProps) => {
  const [showUpdateModal, setShowUpdateModal] = React.useState(false);
  const {
    users,
    pageNumber,
    totalPages,
    setPageNumber
  } = props;
  return <Div>
      {showUpdateModal && <UserManagementModal showUpdateModal={showUpdateModal} setShowUpdateModal={setShowUpdateModal} />}
      <ButtonContainer>
        <Button size={SIZE.compact} onClick={() => setShowUpdateModal(true)}>
          Create or Update User
        </Button>
      </ButtonContainer>
      <Table size={TABLESIZE.spacious} divider={DIVIDER.grid} columns={['Id', 'Email', 'Roles']} overrides={{
      Root: {
        style: {
          maxHeight: '65vh'
        }
      }
    }} data={users.map(user => [user.id, user.email, user.roles.join(', ')])} />
      <Pagination numPages={totalPages} currentPage={pageNumber} onPageChange={({
      nextPage
    }) => {
      setPageNumber(Math.min(Math.max(nextPage, 1), totalPages));
    }} />
    </Div>;
};
export default UserManagement;